import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

// MUI
import { Box } from '@mui/material';

// Icons
import { LocalPhone, Mail } from '@mui/icons-material';

// Styles
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@emotion/react';

// Store

// Components
import CmtCard from '@coremat/CmtCard';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';

// Other
import useTranslateEnum from 'services/Hooks/useTranslateEnum';
import PhoneTypeEnum from 'enums/PhoneTypeEnum';

const useStyles = makeStyles(theme => ({
  iconView: {
    backgroundColor: '#FFDE00',
    color: '#495057',
    padding: 8,
    borderRadius: 0,
    '& .MuiSvgIcon-root': {
      display: 'block',
    },
    '&.web': {
      color: 'theme.palette.warning.main',
    },
  },
  email: {
    color: theme.palette.primary.main,
  },
  wordAddress: {
    wordBreak: 'break-all',
    cursor: 'pointer',
  },
}));

const Contact = ({ userDetail }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { translateEnum } = useTranslateEnum();
  const theme = useTheme();
  const {
    person: { email, personPhones = [] },
  } = userDetail;

  return (
    <CmtCard>
      <CmtCardHeader
        title="Contact"
        style={{ minHeight: '60px' }}
        separator={{
          color: theme.palette.borderColor.dark,
        }}>
        {' '}
        {/* <Fab size="small" color="primary" onClick={handleEditPhoneButton} sx={{ float: 'right', mr: 3, mt: 0 }}>
          <Edit style={{ margin: '0px' }} />
        </Fab> */}
      </CmtCardHeader>

      <CmtCardContent>
        <Box display="flex" alignItems="center" mb={{ xs: 4, sm: 6 }}>
          <Box className={classes.iconView}>
            <Mail />
          </Box>
          <Box ml={5}>
            <Box component="span" fontSize={12} color="text.secondary">
              {t('email')}
            </Box>
            <Box component="p" className={classes.wordAddress} fontSize={16}>
              <Box component="a" href={`mailto:${email}`} className={classes.email}>
                {email}
              </Box>
            </Box>
          </Box>
        </Box>
        {personPhones.length > 0 && (
          <Box display="flex" alignItems="center">
            <Box className={clsx(classes.iconView, 'phone')}>
              <LocalPhone />
            </Box>

            <Box ml={5}>
              <Box component="span" fontSize={12} color="text.secondary">
                {t('phone')}
              </Box>

              {personPhones &&
                personPhones.map((p, index) => (
                  <Box key={index} component="p" className={classes.wordAddress} fontSize={16} color="text.primary">
                    {p.phone.number} {p.phone.postNumber ? `p. ${p.phone.postNumber}` : ''} -{' '}
                    {translateEnum(PhoneTypeEnum, p.phone.phoneType)}
                  </Box>
                ))}
            </Box>
          </Box>
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default Contact;
